import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

import { ReducerStatus } from 'utils/constants';
import ResultModal from 'components/common/modals/ResultModal';
import { detachSubQuestById } from 'store/modules/subquest/subquest-action';
import { subquestActions } from 'store/modules/subquest/subquest-slice';

function RemoveQuestSubQuestMd() {
  const dispatch = useDispatch();

  const removeSubQuest = useSelector((state) => state.subquest.detachSubQuest);

  const handleToggleRemoveModal = (isOpen) => {
    dispatch(subquestActions.setDetachSubQuest({ modal: isOpen }));
  };

  const handleRemoveSubQuest = () => {
    dispatch(
      detachSubQuestById({
        courseId: removeSubQuest.courseId,
        questId: removeSubQuest.questId,
        subQuestId: removeSubQuest.id,
      })
    );
  };

  const handleResultButton = () => {
    handleToggleRemoveModal(false);
    dispatch(
      subquestActions.setDetachSubQuest({
        modal: false,
        id: null,
        questId: null,
        courseId: null,
        status: ReducerStatus.IDLE,
        error: null,
      })
    );
  };

  return (
    <Box>
      {removeSubQuest.status === ReducerStatus.SUCCEEDED ||
      removeSubQuest.status === ReducerStatus.FAILED ? (
        <ResultModal
          isOpen={removeSubQuest.modal}
          onSubmit={handleResultButton}
          isError={removeSubQuest.status === ReducerStatus.FAILED}
          title={
            removeSubQuest.status === ReducerStatus.SUCCEEDED
              ? 'Removed'
              : 'Server Error'
          }
          message={
            removeSubQuest.status === ReducerStatus.SUCCEEDED
              ? 'The selected sub-quest has been detached successfully.'
              : null
          }
        />
      ) : (
        <Modal
          isOpen={removeSubQuest.modal}
          onClose={() => handleToggleRemoveModal(false)}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation Required</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              Are you sure to want to remove this sub-quest from this quest?
              This action will detach the sub-quest from the quest but will not
              delete the sub-quest itself.
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="gray"
                mr={3}
                onClick={() => handleToggleRemoveModal(false)}
              >
                Close
              </Button>
              <Button
                colorScheme="red"
                isLoading={removeSubQuest.status === ReducerStatus.LOADING}
                onClick={() => handleRemoveSubQuest()}
              >
                Proceed
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
}

export default RemoveQuestSubQuestMd;
